"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getColorAndShadeKeys = void 0;
var _lodash = _interopRequireDefault(require("lodash.lowerfirst"));
var ColorAndShadeRegex = /[A-Z][a-z]+|\d+/g;
/**
 * Gets possible keys of `theme.palette` and `theme.palette[color]` objects.
 * @returns Possible keys of `theme.palette` and `theme.palette[color]` objects.
 */ var getColorAndShadeKeys = function(param) {
    var backendColor = param.backendColor, palette = param.palette;
    var parts = backendColor.match(ColorAndShadeRegex);
    if (!parts || parts.length < 2 || parts.length > 4) {
        return null;
    }
    var _parts = _sliced_to_array(parts, 4), part0 = _parts[0], part1 = _parts[1], part2 = _parts[2], part3 = _parts[3];
    if (parts.length === 2) {
        return {
            color: (0, _lodash.default)(part0),
            shade: (0, _lodash.default)(part1)
        };
    }
    if (parts.length === 3 && part0 && part1 && part2) {
        var possibleColor = (0, _lodash.default)(part0 + part1);
        var possibleShade = (0, _lodash.default)(part1 + part2);
        if (Object.keys(palette).includes(possibleColor)) {
            return {
                color: possibleColor,
                shade: (0, _lodash.default)(part2)
            };
        }
        return {
            color: (0, _lodash.default)(part0),
            shade: possibleShade
        };
    }
    /* istanbul ignore next @preserve */ if (parts.length === 4 && part0 && part1 && part2 && part3) {
        return {
            color: (0, _lodash.default)(part0 + part1),
            shade: (0, _lodash.default)(part2 + part3)
        };
    }
    /* istanbul ignore next @preserve */ return null;
};
exports.getColorAndShadeKeys = getColorAndShadeKeys; //# sourceMappingURL=getColorAndShadeKeys.js.map
